export const regretRouletteABI = [
  {
    "inputs": [
      { "internalType": "address", "name": "_regretToken", "type": "address" },
      { "internalType": "address", "name": "_marketingWallet", "type": "address" }
    ],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "anonymous": false,
    "inputs": [
      { "indexed": true, "internalType": "address", "name": "player", "type": "address" },
      { "indexed": false, "internalType": "enum RegretRoulette.PrizeType", "name": "prizeType", "type": "uint8" },
      { "indexed": false, "internalType": "uint256", "name": "amountWon", "type": "uint256" }
    ],
    "name": "Spin",
    "type": "event"
  },
  {
    "inputs": [],
    "name": "SPIN_COST",
    "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "fundContract",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getMysteryOptions",
    "outputs": [
      {
        "components": [{ "internalType": "uint256", "name": "value", "type": "uint256" }],
        "internalType": "struct RegretRoulette.MysteryOption[]",
        "name": "",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getPrizes",
    "outputs": [
      {
        "components": [
          { "internalType": "enum RegretRoulette.PrizeType", "name": "prizeType", "type": "uint8" },
          { "internalType": "uint256", "name": "value", "type": "uint256" },
          { "internalType": "uint256", "name": "probability", "type": "uint256" }
        ],
        "internalType": "struct RegretRoulette.Prize[]",
        "name": "",
        "type": "tuple[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "marketingWallet",
    "outputs": [{ "internalType": "address", "name": "", "type": "address" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "regretToken",
    "outputs": [{ "internalType": "contract IERC20", "name": "", "type": "address" }],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "spin",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      { "internalType": "address", "name": "recipient", "type": "address" },
      { "internalType": "uint256", "name": "amount", "type": "uint256" }
    ],
    "name": "distributePrize",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "withdrawTokens",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
]; 